import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import DoubleDigitCountBubble from 'js/header/FocusedNav/DoubleDigitCountBubble';
import _PositionedDoubleDigitCountBubble from "SmallAccountMenuButton-PositionedDoubleDigitCountBubble.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/SmallAccountMenuButton.tsx?styleId=PositionedDoubleDigitCountBubble";
import _UserButton from "SmallAccountMenuButton-UserButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/SmallAccountMenuButton.tsx?styleId=UserButton";
import _ButtonProfilePic from "SmallAccountMenuButton-ButtonProfilePic.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/SmallAccountMenuButton.tsx?styleId=ButtonProfilePic";


const PositionedDoubleDigitCountBubble = /*#__PURE__*/styled(DoubleDigitCountBubble, null, {
  displayName: "PositionedDoubleDigitCountBubble",
  styles: _PositionedDoubleDigitCountBubble
});

const UserButton = /*#__PURE__*/styled("button", null, {
  displayName: "UserButton",
  styles: _UserButton
});

const ButtonProfilePic = /*#__PURE__*/styled("img", null, {
  displayName: "ButtonProfilePic",
  styles: _ButtonProfilePic
});

type Props = {
  count: number;
  menuOpen: boolean;
  setMenuOpen: (openness: boolean) => void;
};

const AccountMenuButton = ({ count, menuOpen, setMenuOpen }: Props) => {
  const toggle = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <UserButton onClick={toggle} aria-pressed={menuOpen}>
      {currentUser != null && (
        <ButtonProfilePic src={$image_url(currentUser.photo)} />
      )}
      <PositionedDoubleDigitCountBubble count={count} />
    </UserButton>
  );
};

export default AccountMenuButton;
